var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClaim = function SvgClaim(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    stroke: "#212121",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "file-shared")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeWidth: 2,
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 36,
    height: 44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 17,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30h7a7,7,0,0,0-11-5.745"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 21,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,27a7,7,0,0,0-7,7H25A7,7,0,0,0,18,27Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClaim, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/claim.6402bc97.svg";
export { ForwardRef as ReactComponent };